module.exports = __webpack_public_path__ + "static/media/expensescreen.702ca904.png";